import React, { useEffect, useState } from 'react';
import HomeLoanModal from '../../components/HomeLoanModal';
import {
  Typography, Box, Button, Container, TextField,
  InputAdornment, Select, MenuItem, FormControl,
  AppBar, Toolbar, IconButton, useMediaQuery, useTheme, List, ListItem, ListItemText,
  Collapse, Drawer, ListItemIcon, ListItemButton
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHouse, faUser, faPhone, faTag, faBars, faTimes, faPlus, faMinus, faDollarSign } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faTwitter, faInstagram, faYoutube } from '@fortawesome/free-brands-svg-icons';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import starlogo from '../../assets/starlogo.webp';
import smile from '../../assets/smile.webp';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import usertie from '../../assets/usertie.webp';
import city from '../../assets/city.webp';
import NewProjects from './NewProjects';
import EndToEndAssistance from './EndToEndAssistance';
import Blog from './Blog';
import Advertisements from './Advertisements';
import BackgroundImage from '../../assets/bgimglatest.png';
import logo from '../../assets/logo-removebg-preview.png';
import Vector from '../../assets/Vectorsidebar.png';
import { useNavigate } from 'react-router-dom';
import { getallcities, getalllocations } from '../../services/apiService';
import Divider from '@mui/material/Divider';
import TechnologyAndDataSection from './TechnologyAndDataSection';

// Modal data
const statsData = [
  {
    img: starlogo,
    title: 'Zero Brokerage',
    subtitle: 'Services',
    alt: 'Zero Brokerage Icon',
  },
  {
    img: smile,
    title: '200 +',
    subtitle: 'Happy Customers',
    alt: 'Happy Customers Icon',
  },
  {
    img: city,
    title: '500 Cr+',
    subtitle: 'Worth Homes Sold',
    alt: 'Homes Sold Icon',
  },
  {
    img: usertie,
    title: '15+',
    subtitle: 'Relationship Managers',
    alt: 'Relationship Manager Icon',
  },
];


const HeroSection = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  // Navbar states
  const [menuModalOpen, setMenuModalOpen] = useState(false);
  const [rightDrawerOpen, setRightDrawerOpen] = useState(false);
  const [allLocations, setAllLocations] = useState({});
  const [locationCities, setLocationCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState('');
  const [openDropdowns, setOpenDropdowns] = useState({
    hyd: false,
    builders: false,
    projects: false,
    guide: false,
  });

  // Hero section states
  const [selectedLocation, setSelectedLocation] = React.useState('');
  const [searchValue, setSearchValue] = React.useState('');
  const [locationOptions, setLocationOptions] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  // Modal state
  const [homeLoanModalOpen, setHomeLoanModalOpen] = useState(false);

  // Navbar data
  const navItems = [
    { 
      text: 'Get a Home Loan', 
      icon: '#', 
      path: '#', 
      isSpecial: true,
      onClick: () => setHomeLoanModalOpen(true)
    },
    { text: 'Home', icon: faHouse, path: '/' },
    { text: 'About Us', icon: faUser, path: '/aboutus' },
    { text: 'Contact Us', icon: faPhone, path: '/contactus' },
    { text: 'Offers', icon: faTag, path: '/propertylist', isSpecial: true },
  ];

  const modalData = {
    locations: [
      "Change Location",
      "Hyderabad",
    ],
    sections: [
      {
        id: "hyd",
        title: "Properties in Hyderabad",
        items: allLocations,
      },
      {
        id: "builders",
        title: "Top Builders",
        items: [
          { name: "Prestige", path: "" },
          { name: "Lodha", path: "" },
          { name: "Brigade", path: "" },
          { name: "Godrej", path: "" }
        ]
      },
      {
        id: "projects",
        title: "Popular Projects",
        items: [
          { name: "Prestige High Fields", path: "" },
          { name: "Lodha Meridian", path: "" },
          { name: "Brigade at No.7", path: "" },
          { name: "Godrej Oasis", path: "" }
        ]
      },
      {
        id: "guide",
        title: "Property Guide",
        items: [
          { name: "Builder Partners", path: "/builder-partners" },
          { name: "Docs Required for Home Loan", path: "/docs-required" },
          { name: "EMI Calculator", path: "/emi-calculator" },
          { name: "FAQ'S", path: "/faqs" },
          { name: "Blogs", path: "/blogs" }, { name: "Home Loan", path: "/home-loan" },
          { name: "Property Buying Steps", path: "/property-buying-steps" },
          { name: "Vaastu Tips", path: "/vaastu-tips" },
        ]
      },
    ],
    contact: {
      phone: "+91 970 540 1575"
    },
    socialIcons: [
      { name: 'facebook-f', component: faFacebookF },
      { name: 'twitter', component: faTwitter },
      { name: 'instagram', component: faInstagram },
      { name: 'youtube', component: faYoutube }
    ]
  };

  // Navbar functions
  const toggleRightDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setRightDrawerOpen(open);
  };

  const handleMenuModalToggle = () => {
    if (menuModalOpen && document.activeElement) {
      document.activeElement.blur();
    }
    setMenuModalOpen(!menuModalOpen);
  };

  const handleDropdownToggle = (key) => {
    setOpenDropdowns((prev) => {
      const newState = Object.keys(prev).reduce((acc, k) => {
        acc[k] = false;
        return acc;
      }, {});
      newState[key] = !prev[key];
      return newState;
    });
  };

  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const response = await getallcities();
        const cities = response?.cities || [];

        if (cities.length > 0) {
          setLocationOptions(cities);
        } else {
          setLocationOptions([]);
        }
      } catch (error) {
        console.error('Error fetching cities:', error);
        setLocationOptions([]);
      } finally {
        setLoading(false);
      }
    };

    fetchLocations();
  }, []);

  // Fetch navbar locations
  useEffect(() => {
    const fetchNavbarLocations = async () => {
      const response = await getalllocations();
      const cities = response.locations ? Object.keys(response.locations) : Object.keys(response);
      const locationsObj = response.locations || response;
      setAllLocations(locationsObj);
      setLocationCities(cities);
      setSelectedCity(cities[0] || '');
    };
    fetchNavbarLocations();
  }, []);

  const handleLocationChange = (event) => {
    setSelectedLocation(event.target.value || '');
  };

  const handleLetsGo = () => {
    const params = new URLSearchParams();

    // Add location to URL if it's selected
    if (selectedLocation) {
      params.set('location', selectedLocation);
    }

    // Add search value if it exists
    if (searchValue) {
      params.set('search', searchValue);
    }

    // Navigate with both URL parameters and state
    navigate({
      pathname: '/propertylist',
      search: params.toString(),
      state: {
        location: selectedLocation || '',
        search: searchValue || ''
      }
    });
  };

  // Navbar drawer components
  const rightDrawer = (
    <Box
      sx={{ width: 245 }}
      role="presentation"
      onClick={toggleRightDrawer(false)}
      onKeyDown={toggleRightDrawer(false)}
    >
      <List>
        {navItems.map((item) => (
          <ListItemButton key={item.text} onClick={() => navigate(item.path)} >
            <ListItemIcon>
              <FontAwesomeIcon icon={item.icon} style={{ color: '#d10000' }} />
            </ListItemIcon>
            <ListItemText sx={{ py: 1.5, fontWeight: 600 }} primary={item.text} />
          </ListItemButton>
        ))}
      </List>
      <Divider />
      <Box sx={{ p: 2, textAlign: 'center' }}>
        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
          Follow Us
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 1 }}>
          <IconButton size="small">
            <FontAwesomeIcon icon={faFacebookF} style={{ color: '#1877f2' }} />
          </IconButton>
          <IconButton size="small">
            <FontAwesomeIcon icon={faTwitter} style={{ color: '#1da1f2' }} />
          </IconButton>
          <IconButton size="small">
            <FontAwesomeIcon icon={faInstagram} style={{ color: '#e4405f' }} />
          </IconButton>
          <IconButton size="small">
            <FontAwesomeIcon icon={faYoutube} style={{ color: '#ff0000' }} />
          </IconButton>
        </Box>
      </Box>
    </Box>
  );

  // Left Side Menu Drawer
  const menuDrawer = (
    <Box sx={{ width: 280, bgcolor: '#fff', height: '100vh', boxShadow: 3, p: 2, display: 'flex', flexDirection: 'column', }}>
      {/* Close Button */}
      <IconButton onClick={handleMenuModalToggle} sx={{ alignSelf: 'flex-end', mb: 1, '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' } }}>
        <FontAwesomeIcon icon={faTimes} style={{ color: '#666' }} />
      </IconButton>
      {/* Location Dropdown */}
      <Select
        fullWidth
        size="small"
        value={selectedCity}
        onChange={e => setSelectedCity(e.target.value)}
        sx={{ mb: 2, cursor: 'pointer' }}
        MenuProps={{
          disableScrollLock: true,
          PaperProps: {
            style: {
              maxHeight: 290,
              zIndex: 9999
            }
          },
          MenuListProps: {
            'aria-labelledby': 'location-select-label'
          }
        }}
        inputProps={{
          'aria-label': 'Select city',
          id: 'location-select'
        }}
      >
        {locationCities.map((city) => (
          <MenuItem key={city} value={city}>{city}</MenuItem>
        ))}
      </Select>

      {/* Dynamic Sections */}
      <List disablePadding sx={{ mb: 2 }}>
        {/* Dynamic City/Location Section */}
        {selectedCity && (
          <div key={selectedCity}>
            <ListItem
              component="div"
              onClick={() => handleDropdownToggle(selectedCity)}
              sx={{
                py: 1,
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.04)'
                }
              }}
            >
              <ListItemText primary={<span style={{ fontWeight: 600, color: '#222' }}>{`Properties in ${selectedCity}`}</span>} />
              <FontAwesomeIcon icon={openDropdowns[selectedCity] ? faMinus : faPlus} />
            </ListItem>
            <Collapse in={openDropdowns[selectedCity]} timeout="auto" unmountOnExit>
              <List disablePadding>
                {(allLocations[selectedCity] || []).map((location) => (
                  <ListItem
                    key={location}
                    component="div"
                    sx={{
                      pl: 4,
                      py: 0.5,
                      cursor: 'pointer',
                      '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)'
                      }
                    }}
                    onClick={() => {
                      setMenuModalOpen(false);
                      const searchParams = new URLSearchParams(window.location.search);

                      if (location && location.toLowerCase() !== 'all') {
                        searchParams.set('location', location);
                      } else {
                        searchParams.delete('location');
                      }

                      navigate({
                        pathname: '/propertylist',
                        search: searchParams.toString(),
                        state: { location: location || '' },
                        replace: true
                      });
                    }}
                  >
                    <ListItemText
                      primary={location}
                      primaryTypographyProps={{ fontSize: 14 }}
                    />
                  </ListItem>
                ))}
              </List>
            </Collapse>
            <Divider />
          </div>
        )}

        {/* Static Dummy Sections */}
        {[
          {
            id: "builders",
            title: "Top Builders",
            items: [
              { name: "Prestige", path: "" },
              { name: "Lodha", path: "" },
              { name: "Brigade", path: "" },
              { name: "Godrej", path: "" }
            ]
          },
          {
            id: "projects",
            title: "Popular Projects",
            items: [
              { name: "Prestige High Fields", path: "" },
              { name: "Lodha Meridian", path: "" },
              { name: "Brigade at No.7", path: "" },
              { name: "Godrej Oasis", path: "" }
            ]
          },
          {
            id: "guide",
            title: "Property Guide",
            items: [
              { name: "Builder Partners", path: "/builder-partners" },
              { name: "Docs Required for Home Loan", path: "/docs-required" },
              { name: "EMI Calculator", path: "/emi-calculator" },
              { name: "FAQ'S", path: "/faqs" }, { name: "Blogs", path: "/blogs" },
              { name: "Home Loan", path: "/home-loan" },
              { name: "Property Buying Steps", path: "/property-buying-steps" },
              { name: "Vaastu Tips", path: "/vaastu-tips" },
            ]
          },
          {
            id: "home-loan-facility",
            title: "Home Loan Facility",
            path: "/home-loan-facility",
            isLink: true
          },
          {
            id: "interior-design",
            title: "Interior Design",
            path: "/interior-design",
            isLink: true
          }
        ].map((section) => (
          <div key={section.id}>
            {section.isLink ? (
              <>
                <ListItem
                  component="div"
                  onClick={() => {
                    setMenuModalOpen(false);
                    navigate(section.path);
                  }}
                  sx={{
                    py: 1,
                    cursor: 'pointer',
                    '&:hover': {
                      backgroundColor: 'rgba(0, 0, 0, 0.04)'
                    }
                  }}
                >
                  <ListItemText
                    primary={<span style={{ fontWeight: 600, color: '#222' }}>{section.title}</span>}
                  />
                </ListItem>
                <Divider />
              </>
            ) : (
              <>
                <ListItem
                  component="div"
                  onClick={() => handleDropdownToggle(section.id)}
                  sx={{
                    py: 1,
                    cursor: 'pointer',
                    '&:hover': {
                      backgroundColor: 'rgba(0, 0, 0, 0.04)'
                    }
                  }}
                >
                  <ListItemText
                    primary={<span style={{ fontWeight: 600, color: '#222' }}>{section.title}</span>}
                  />
                  <FontAwesomeIcon icon={openDropdowns[section.id] ? faMinus : faPlus} />
                </ListItem>
                <Collapse in={openDropdowns[section.id]} timeout="auto" unmountOnExit>
                  <List disablePadding>
                    {section.items.map((item) => (
                      <ListItemButton
                        key={item.name}
                        sx={{
                          pl: 4, py: 0.5, cursor: 'pointer',
                          '&:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0.04)'
                          }
                        }}
                        onClick={() => {
                          setMenuModalOpen(false);
                          if (item.path) {
                            navigate(item.path);
                          }
                        }}
                      >
                        <ListItemText
                          primary={item.name}
                          primaryTypographyProps={{ fontSize: 14 }}
                        />
                      </ListItemButton>
                    ))}
                  </List>
                </Collapse>
                <Divider />
              </>
            )}
          </div>
        ))}
      </List>

      {/* Contact Number */}
      <Button fullWidth variant="text" sx={{ color: '#d10000', fontWeight: 600, mb: 2, justifyContent: 'flex-start', pl: 1 }} startIcon={<FontAwesomeIcon icon={faPhone} />}>
        {modalData.contact.phone}
      </Button>

      {/* Social Icons */}
      <Box sx={{ mt: 'auto', mb: 4, display: 'flex', gap: 2, alignItems: 'center', pl: 1 }}>
        {modalData.socialIcons.map((icon) => (
          <IconButton key={icon.name} size="small">
            <FontAwesomeIcon icon={icon.component} style={{ color: '#a6a6a6' }} />
          </IconButton>
        ))}
      </Box>
    </Box>
  );

  return (
    <Box>
      {/* Navbar Drawers */}
      <Drawer anchor="left" open={menuModalOpen} onClose={handleMenuModalToggle} sx={{
        '& .MuiDrawer-paper': {
          width: 310, boxSizing: 'border-box',
          overflowY: 'auto', msOverflowStyle: 'none',
          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': {
            display: 'none',
          },
        },
      }}>
        {menuDrawer}
      </Drawer>
      <Drawer anchor="right" open={rightDrawerOpen} onClose={toggleRightDrawer(false)}>{rightDrawer}</Drawer>
      
      {/* Home Loan Modal */}
      <HomeLoanModal 
        open={homeLoanModalOpen} 
        onClose={() => setHomeLoanModalOpen(false)}
        onSubmit={(formData) => {
          // Handle form submission here (e.g., API call)
          console.log('Form submitted:', formData);
          // You can add your form submission logic here
        }}
      />

      {/* Hero Section with Integrated Navbar */}
      <Box
        sx={{
          backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5))',
          backgroundSize: 'contain', backgroundPosition: 'center center', backgroundRepeat: 'no-repeat',
          minHeight: '80vh', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start',
          color: 'white', textAlign: 'center', position: 'relative',
          padding: { xs: '0 0%', sm: '0 8%', md: '0 4%' },
          '&::before': {
            content: '""', position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundImage: `url(${BackgroundImage})`,
            backgroundSize: 'cover', backgroundPosition: 'center center', zIndex: -1,  backgroundRepeat: 'no-repeat',
          },
        }}
      >
        {/* Integrated Navbar */}
        <AppBar position="static" sx={{ boxShadow: 'none', backgroundColor: 'transparent', zIndex: 900, transition: 'all 0.3s ease', }}
          elevation={0}
        >
          {/* <Container maxWidth="xl"> */}
          <Box
            sx={{
               borderRadius: '0', height: '80px',
              minHeight: { xs: '80px', md: '80px' }, width: '100%',
              transition: 'all 0.3s ease',
            }}
          >
            <Toolbar
              sx={{
                minHeight: { xs: '80px', md: '80px' },
                transition: 'all 0.3s ease',
                display: 'flex', alignItems: 'center',
                justifyContent: 'space-between', p: 0,
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <IconButton onClick={handleMenuModalToggle}
                  sx={{ p: 0, '&:hover': { backgroundColor: 'transparent', }, }}  >
                  <img loading='lazy' src={Vector} alt="Menu" style={{ height: '18px', cursor: 'pointer' }} />
                </IconButton>
                <img loading='lazy' src={logo} onClick={() => navigate('/')} alt="Logo" style={{ height: '40px', cursor: 'pointer' }} />
              </Box>
              <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 3 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                  {navItems.map((item) => (
                    <Button
                      disableElevation
                      disableRipple
                      disableFocusRipple
                      key={item.text}
                      onClick={item.onClick || (() => navigate(item.path))}
                      sx={{
                        color: 'white',
                        textTransform: 'none',
                        fontWeight: 600,
                        fontSize: { xs: '14px', md: '16px' },
                        minWidth: 'auto',
                        px: { xs: 1, md: 2 },
                        ...((item.isSpecial) && {
                          border: '1px solid white',
                          borderRadius: '5px',
                          '&:hover': {
                            bgcolor: 'white !important',
                            color: '#d10000',
                            boxShadow: 'none',
                          },
                        }),
                        ...(!item.isSpecial && {
                          '&:hover': {
                            color: '#d10000',
                            backgroundColor: 'transparent',
                            boxShadow: 'none',
                          },
                        }),
                      }}
                    >
                      <FontAwesomeIcon
                        icon={item.icon}
                        style={{
                          marginRight: '8px',
                          fontSize: '15px',
                        }}
                      />
                      <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>
                        {item.text}
                      </Box>
                    </Button>
                  ))}
                  
                  {/* Phone Number */}
                  <Box sx={{ 
                    display: 'flex', 
                    alignItems: 'center',
                    color: 'white',
                    ml: 1,
                    '&:hover': {
                      color: '#d10000',
                      '& svg': {
                        transform: 'scale(1.1)'
                      }
                    },
                    transition: 'all 0.3s ease',
                    cursor: 'pointer'
                  }}>
                    <FontAwesomeIcon 
                      icon={faPhone} 
                      style={{ 
                        marginRight: '8px',
                        fontSize: '14px',
                        transition: 'all 0.3s ease'
                      }} 
                    />
                    <Typography 
                      variant="body1" 
                      sx={{ 
                        fontWeight: 600,
                        fontSize: { xs: '14px', md: '16px' },
                        whiteSpace: 'nowrap'
                      }}
                      onClick={() => window.location.href = 'tel:+919705401575'}
                    >
                      +91 9705401575
                    </Typography>
                  </Box>
                </Box>
              </Box>
              {/* Right side hamburger menu for mobile */}
              {isMobile && (
                <IconButton
                  onClick={toggleRightDrawer(true)}
                  sx={{
                    ml: 'auto',
                    color: 'white',
                    '&:hover': {
                      backgroundColor: 'transparent',
                    },
                  }}
                >
                  <FontAwesomeIcon icon={faBars} style={{ fontSize: '24px' }} />
                </IconButton>
              )}
              
            </Toolbar>
          </Box>
          {/* </Container> */}
        </AppBar>

        {/* Hero Content */}
        <Box sx={{
          position: 'relative', zIndex: 2, width: '100%', flex: 1,
          display: 'flex', flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center', mb: '100px',
          transform: { xs: 'scale(0.9)', sm: 'scale(0.95)', md: 'scale(1)' },
          transition: 'all 0.3s ease',
          '& > *': {
            transform: { xs: 'scale(0.9)', sm: 'scale(0.95)', md: 'scale(1)' },
            transformOrigin: 'top center',
            paddingTop: { xs: '10px', sm: '20px', md: 0 }
          }
        }}>
          <Container maxWidth="xl" disableGutters>
            <Box sx={{ maxWidth: { xs: '100%', sm: '90%', md: '100%' }, mx: 'auto' }}>
              <Typography variant="h2" sx={{
                fontSize: { xs: '34px', sm: '40px', md: '48px', lg: '40px' },
                fontWeight: 560,
                mb: { xs: 2, md: 4 },

                '& br': {
                  display: { xs: 'block', sm: 'none' }
                }
              }}>
                0% Brokerage.<br />100% Happiness.
                {/* Zero Brokerage.<br /> Pure Happiness. */}
              </Typography>
            </Box>

            <Box sx={{
              backgroundColor: 'white', borderRadius: '8px',
              maxWidth: { xs: '100%', sm: '700px' },
              mx: 'auto', display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              alignItems: 'stretch', minHeight: '32px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              overflow: 'hidden',
              '& > *:not(:last-child)': {
                borderRight: { xs: 'none', sm: '1px solid #e0e0e0' },
                borderBottom: { xs: '1px solid #e0e0e0', sm: 'none' }, margin: 0
              },
              '& button': {
                borderRadius: { xs: '0 0 8px 8px', sm: '0 8px 8px 0' },
                height: '100% !important', minHeight: '48px', alignSelf: 'stretch'
              }
            }}>
              <FormControl variant="outlined" sx={{
                minWidth: { xs: '100%', sm: '160px' },
                '& .MuiOutlinedInput-notchedOutline': {
                  border: 'none', borderRadius: 0,
                },
                '& .MuiOutlinedInput-root': {
                  height: '100%', padding: { xs: '6px 10px', sm: '0 10px' },
                },
                '& .MuiSelect-select': {
                  display: 'flex', alignItems: 'center', height: '100% !important',
                  padding: { xs: '6px 10px', sm: '0 10px 0 6px !important' },
                },
              }}>
                <Select
                  value={selectedLocation}
                  onChange={handleLocationChange}
                  displayEmpty
                  disabled={loading || locationOptions.length === 0}
                  inputProps={{ 'aria-label': 'Location' }}
                  startAdornment={
                    <LocationOnIcon color="action" sx={{ mr: 1, color: '#666' }} />
                  }
                  renderValue={(selected) => {
                    if (loading) return 'Loading...';
                    if (!selected) return <em>All</em>;
                    return selected;
                  }}
                  sx={{
                    '& .MuiSelect-icon': {
                      right: '8px',
                    },
                    '& .MuiSelect-select': {
                      display: 'flex',
                      alignItems: 'center',
                      height: '100% !important',
                      padding: { xs: '8px 12px', sm: '0 12px 0 8px !important' },
                    },
                  }}
                >
                  <MenuItem value=""><em>All</em></MenuItem>
                  {locationOptions.map((loc) => (
                    <MenuItem key={loc} value={loc}>
                      {loc}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Box sx={{ flex: 1, display: 'flex', alignItems: 'center' }}>
                <TextField
                  variant="outlined" placeholder="Enter a Builder, Project or RERA ID"
                  fullWidth
                  value={searchValue}
                  onChange={e => setSearchValue(e.target.value)}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      height: '100%', '& fieldset': { border: 'none', },
                      '& input': {

                        padding: { xs: '8px 12px', sm: '0 12px' },
                        height: '100%',
                      },
                    },
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start" sx={{ display: { xs: 'none', sm: 'flex' }, ml: 1 }}>

                      </InputAdornment>
                    ),
                  }}
                />
              </Box>

              <Button
                sx={{
                  backgroundColor: '#d10000',
                  color: 'white',
                  px: { xs: 2, md: 4 },
                  minWidth: '120px',
                  textTransform: 'none',
                  '&:hover': {
                    backgroundColor: '#b30000',
                  },
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: 'none',
                  margin: 0,
                  padding: 0,
                  whiteSpace: 'nowrap',
                }}
                onClick={handleLetsGo}
              >
                Let's Go <ChevronRightIcon />
              </Button>
            </Box>

          </Container>

        </Box>

        {/* banner */}
        <Box
          sx={{
            backgroundColor: '#2B0B0B44', color: 'white', display: 'flex', justifyContent: 'center',
            alignItems: 'center', position: 'absolute', bottom: 0, left: 0, right: 0, zIndex: 1,
            py: { xs: 2, sm: 2.5, md: 1 }, px: { xs: 2, sm: 3, md: 4, lg: 8 },
            width: '100%', boxSizing: 'border-box', overflow: 'hidden'
          }}
        >
          <Container maxWidth="xl" sx={{ px: { xs: 0, sm: 2 } }}>
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: {
                  xs: '1fr 1fr',
                  sm: 'repeat(4, 1fr)',
                },
                gap: { xs: 3, sm: 2, md: 4 },
                width: '100%',
                maxWidth: '100%',
                margin: '0 auto',
                '& > *': {
                  minWidth: 0, // Prevents flex items from overflowing
                }
              }}
            >
              {statsData.map((stat, index) => (
                <Box key={index} sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', sm: 'row' },
                  alignItems: 'center', gap: { xs: 1, sm: 2 }, textAlign: { xs: 'center', sm: 'left' },
                  px: { xs: 1, sm: 2 },
                  '&:not(:last-child)': {
                    borderRight: { sm: '1px solid rgba(255,255,255,0.2)' },
                    pr: { sm: 2, md: 3 },
                  },
                  '&:last-child': {
                    pr: 0
                  }
                }}
                >
                  <Box component="img" src={stat.img} alt={stat.alt} loading='lazy'
                    sx={{
                      width: { xs: '36px', sm: '40px', md: '40px' }, height: { xs: '36px', sm: '40px', md: '40px' },
                      objectFit: 'contain', mb: { xs: 1, sm: 0 }
                    }}
                  />
                  <Box sx={{ minWidth: 0 }}>
                    <Typography variant="h3"
                      sx={{
                        fontWeight: 700,
                        fontSize: { xs: '1.1rem', sm: '1.25rem', md: '1.1rem' },
                        lineHeight: 1.2, whiteSpace: 'nowrap',
                        overflow: 'hidden', textOverflow: 'ellipsis'
                      }}
                    >
                      {stat.title}
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: { xs: '0.8rem', sm: '0.875rem', md: '0.8rem' },
                        opacity: 0.9,
                        mt: { xs: 0.25, sm: 0.5 },
                        whiteSpace: { xs: 'normal', sm: 'nowrap' }
                      }}
                    >
                      {stat.subtitle}
                    </Typography>
                  </Box>
                </Box>
              ))}
            </Box>
          </Container>
        </Box>
      </Box>

      <NewProjects />
      <EndToEndAssistance />
      {/* <TechnologyAndDataSection/> */}
      <Advertisements />
      <Blog />
    </Box>
  );
};

export default HeroSection;

